// assets
import './StripesRevealer.scss';

const defaults = {
  revealerElement: null,
  stripesCount: 1,
  stripesDirection: 'vertical',
  stripesColor: '#FFFFFF',
  isText: false,
  nameSpace: 'stripes-revealer',
  revealerTarget: '[data-role*="reveal-target"]',
};

export default class StripesRevealer {
  constructor(props) {
    const options = Object.assign({}, defaults, props);

    this.revealerElement = options.revealerElement;
    if (!this.revealerElement) return;

    this.nameSpace = options.nameSpace;
    this.revealerTarget = this.revealerElement.querySelector(options.revealerTarget);
    this.stripesCount = options.stripesCount;
    this.stripesDirection = options.stripesDirection;
    this.stripesColor = options.stripesColor;
    this.isText = options.isText;

    this.init();
  }

  createSVG() {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('fill', this.stripesColor);
    svg.setAttribute('viewBox', '0 0 100 150');
    return svg;
  }

  createStripeRect(svg, position, width, height) {
    let units = '%';
    if (this.isText) {
      units = 'px';
    }
    const h = height || '100%';
    const rectElement = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    rectElement.setAttribute('class', 'stripe');
    if (this.stripesDirection === 'vertical') {
      rectElement.setAttribute('width', width + 0.15 + units);
      rectElement.setAttribute('x', position + units);
      rectElement.setAttribute('height', h);
    } else {
      rectElement.setAttribute('height', width + 0.15 + units);
      rectElement.setAttribute('y', position + units);
      rectElement.setAttribute('width', h);
    }

    svg.appendChild(rectElement);
  }

  init() {
    const that = this;
    const stripesItem = document.createElement('div');
    const stripesSVG = that.createSVG();
    this.revealerElement.classList.add(this.nameSpace);
    this.revealerTarget.classList.add(`${this.nameSpace}__target`);
    stripesItem.classList.add(`${this.nameSpace}__stripes`);
    this.revealerElement.appendChild(stripesItem);

    if (that.isText) {
      const textElements = this.revealerElement.children;
      this.stripeCount = textElements.length - 1;// minus last element - svg container
      for (let i = 0; i < this.stripeCount; i += 1) {
        const width = textElements[i].offsetHeight;
        let pos = 0;
        if (i > 0) {
          let heightTotal = 0;
          for (let k = i - 1; k >= 0; k -= 1) {
            heightTotal += textElements[k].offsetHeight;
          }
          pos = heightTotal;
        }
        this.createStripeRect(stripesSVG, pos, width);
      }
    } else {
      const width = 100 / that.stripesCount;
      for (let j = 0; j < that.stripesCount; j += 1) {
        const pos = width * j;
        that.createStripeRect(stripesSVG, pos, width);
      }
    }
    stripesItem.appendChild(stripesSVG);
  }
}



// WEBPACK FOOTER //
// ./components/StripesRevealer/StripesRevealer.js